export function objectToQueryString(obj: Record<string, string | number | boolean | null | undefined>): string {
  return Object.entries(obj)
    .reduce<string[]>((acc, [key, value]) => (value ? [...acc, `${key}=${encodeURIComponent(value)}`] : acc), [])
    .join("&");
}
